import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '@/router/index.js';

Vue.use(Vuex);

// axios.defaults.baseURL = 'https://api.beeperf.com/api';
axios.defaults.baseURL = 'https://backend.beeperf.com/api';
if (process.env.NODE_ENV === 'development') {
   axios.defaults.baseURL = 'http://beeperf-lite-backend.test/api';
}

export default new Vuex.Store({
   state: {
      titre: 'Gestion des ruches',
      token: localStorage.getItem('access_token') || null,
      user: {},
      types_ruches: ['Dadant', 'Langstroth', 'Voirnot', 'Warré']
   },
   getters: {
      role(state) {
         return state.user.role;
      },
      loggedIn(state) {
         return state.token != null;
      }
   },
   mutations: {
      setTitre(state, titre) {
         state.titre = titre;
      },
      setUser(state, user) {
         state.user = user;
      },
      login(state, token) {
         state.token = token;
      },
      logout(state) {
         state.token = null;
      }
   },
   actions: {
      // récupérer l'utilisateur
      getUser(context) {
         axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
         return new Promise((resolve, reject) => {
            axios
               .get('/user')
               .then(res => {
                  context.commit('setUser', res.data);
                  resolve(res);
               })
               .catch(err => {
                  reject(err);
               });
         });
      },
      login(context, credentials) {
         axios
            .post('/login', {
               username: credentials.username,
               password: credentials.password
            })
            .then(res => {
               if (res.data.erreur) {
                  router.push({
                     name: 'logout',
                     params: { message: res.data.erreur }
                  });
               } else {
                  const token = res.data.access_token;
                  localStorage.setItem('access_token', token);
                  context.commit('login', token);
                  router.push({
                     name: 'dashboard'
                  });
               }
            });
      },
      logout(context) {
         if (context.getters.loggedIn) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
            return new Promise((resolve, reject) => {
               axios
                  .post('/logout')
                  .then(res => {
                     localStorage.removeItem('access_token');
                     context.commit('logout');
                     resolve(res);
                  })
                  .catch(err => {
                     localStorage.removeItem('access_token');
                     context.commit('logout');
                     reject(err);
                  });
            });
         }
      }
   },
   modules: {}
});
